/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseGuideSetting } from '../../models/api-response-guide-setting';
import { GuideSetting } from '../../models/guide-setting';

export interface Save$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: GuideSetting
}

export function save(http: HttpClient, rootUrl: string, params: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseGuideSetting>> {
  const rb = new RequestBuilder(rootUrl, save.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseGuideSetting>;
    })
  );
}

save.PATH = '/v1/api/admin-ui/guide-setting/save';
